export function calculateOnce(callback) {
    var result = undefined;
    return function () {
        if (result === undefined) {
            result = callback();
        }
        return result;
    };
}
//# sourceMappingURL=calculate-once.js.map